import React from "react";

const HeaderDashboard = (props) => {
  return (
    <div className="heade-dash-main ">
      <div className="col-12 text-right">
        <h3 className="col-12">ایستگاه ها</h3>
      </div>
      <div className="col-12 content-header">
        <div className="col-12 header-dash-content">
          <p>تعداد چکپوینت های ثبت شده</p>
          <span>{props.data?.checkpointCount}</span>
        </div>
        <div className="col-12 header-dash-content">
          <p>تعداد مهارت های ثبت شده</p>
          <span>{props.data?.skillCount}</span>
        </div>
        <div className="col-12 w-100 header-dash-content">
          <p>تعداد سطوح ثبت شده</p>
          <span>{props.data?.levelCount}</span>
        </div>
        <div className="col-12 header-dash-content">
          <p>تعداد دروس ثبت شده</p>
          <span>{props.data?.lessonCount}</span>
        </div>
        <div className="col-12 header-dash-content">
          <p>تعداد سوالات ثبت شده</p>
          <span>{props.data?.questionCount}</span>
        </div>
      </div>
    </div>
  );
};

export default HeaderDashboard;
